import { Form } from './Form';

export class PricesForm extends Form {

  constructor(formEl, wrapperEl, headerEl, cb, emailType, selectedApps, gaCategoryType, gaEventType) {
    super(formEl, emailType, gaCategoryType, gaEventType);

    this._selectedApps = selectedApps;
    this.wrapperEl = wrapperEl;
    this.headerEl = headerEl;
    this.showConfirmationEl = cb;
  }

  prepareFormData() {
    this.prepareSelectBoxData();

    this.formEl.querySelectorAll('.contact-form__field').forEach(({ name, value }) => this.formData.append(name, value));
    this.formData.append(`additionalParameters.language`, document.documentElement.lang);
    this.formData.append(`additionalParameters.company`, this.formData.get('company'));

    for(const property in this._selectedApps) {
      this.formData.append('products', `${ this._selectedApps[property] }x ${ property }`)
    }

    this.formData.delete('company');
  }

  afterFormSendTracking() {
    if (window.lintrk) {
      window.lintrk('track', { conversion_id: 8350657 });
    }
  }

  showNotification() {
   this.formEl.classList.add('d-none');
   this.wrapperEl.classList.add('d-none');
   this.headerEl.classList.add('d-none');
   this.showConfirmationEl();
  }
}
